import React, { useCallback, useEffect, useState } from 'react';
import painelApi from '../../services/painelApi';

// Painel de Clientes → Monitoramento: alertas abertos e situação de cada site.
const SITUACAO = {
  ok: { txt: 'No ar', cor: '#166534' },
  fora_do_ar: { txt: 'Fora do ar', cor: '#b91c1c' },
  sem_monitor: { txt: 'Sem monitoramento', cor: '#92400e' },
  sem_coleta: { txt: 'Aguardando coleta', cor: '#64748b' },
};
const dataHora = v => (v ? new Date(v).toLocaleString('pt-BR') : '—');
const th = { textAlign: 'left', padding: '6px 8px', background: '#f1f5f9', fontSize: 12 };
const td = { padding: '6px 8px', fontSize: 13, borderBottom: '1px solid #e5e7eb', verticalAlign: 'top' };

export default function MonitorSites() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');

  const carregar = useCallback(() => {
    setErro('');
    painelApi.get('/painel-clientes/monitor')
      .then(r => setDados(r.data))
      .catch(e => setErro(e.response?.data?.erro || 'Não foi possível carregar o monitoramento.'));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  if (erro) return <div style={{ padding: 16, color: '#b91c1c' }}>{erro}</div>;
  if (!dados) return <div style={{ padding: 16 }}>Carregando…</div>;

  const graves = dados.alertas.filter(a => a.nivel === 'grave').length;
  const versoes = new Set(dados.sites.map(s => s.versao).filter(Boolean));

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
        <strong style={{ fontSize: 15, color: graves ? '#b91c1c' : '#166534' }}>
          {graves ? `${graves} problema(s) grave(s)` : 'Nenhum problema grave'}
        </strong>
        <span style={{ fontSize: 13, color: '#475569' }}>{dados.alertas.length - graves} aviso(s)</span>
        <span style={{ fontSize: 13, color: '#475569' }}>{versoes.size} versão(ões) em uso</span>
        <button type="button" onClick={carregar} style={{ padding: '4px 12px', cursor: 'pointer' }}>↻ Atualizar</button>
      </div>

      <h3 style={{ fontSize: 14, margin: '8px 0' }}>Alertas abertos</h3>
      {dados.alertas.length === 0 ? <p style={{ fontSize: 13, color: '#64748b' }}>Nenhum alerta aberto.</p> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Nível</th><th style={th}>Site</th><th style={th}>Problema</th><th style={th}>Desde</th></tr></thead>
            <tbody>
              {dados.alertas.map(a => (
                <tr key={a.id}>
                  <td style={{ ...td, fontWeight: 700, color: a.nivel === 'grave' ? '#b91c1c' : '#92400e' }}>{a.nivel === 'grave' ? 'Grave' : 'Aviso'}</td>
                  <td style={td}>{a.site}</td>
                  <td style={td}>{a.titulo}{a.detalhe && <div style={{ fontSize: 12, color: '#64748b' }}>{a.detalhe}</div>}</td>
                  <td style={td}>{dataHora(a.primeira_em)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h3 style={{ fontSize: 14, margin: '16px 0 8px' }}>Sites</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Site</th><th style={th}>Situação</th><th style={th}>Versão</th><th style={th}>Última coleta</th></tr></thead>
          <tbody>
            {dados.sites.map(s => {
              const st = SITUACAO[s.situacao] || SITUACAO.sem_coleta;
              return (
                <tr key={s.chave}>
                  <td style={td}>{s.nome}</td>
                  <td style={{ ...td, color: st.cor, fontWeight: 600 }}>{st.txt}</td>
                  <td style={{ ...td, fontFamily: 'monospace' }}>{s.versao || '—'}</td>
                  <td style={td}>{dataHora(s.ultima_coleta)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
